import { useEffect, useState } from 'react'
import api from '../api/client'

/**
 * <img> para una imagen que vive detrás de la sesión (endpoints de /api).
 * El navegador pide el src sin el token y el servidor responde 401: por eso la
 * foto candidata nunca se veía (Martin, 19 sep 2026). Acá se baja con el
 * cliente autenticado y se muestra desde memoria.
 */
export default function ImagenAutenticada({ url, alt, style, onClick, title }) {
  const [src, setSrc] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let vivo = true
    let objeto = null
    setSrc(null); setError(false)
    api.get(url, { responseType: 'blob' })
      .then(({ data }) => {
        if (!vivo) return
        objeto = URL.createObjectURL(data)
        setSrc(objeto)
      })
      .catch(() => { if (vivo) setError(true) })
    return () => { vivo = false; if (objeto) URL.revokeObjectURL(objeto) }
  }, [url])

  if (error) return <div style={{ ...style, display: 'grid', placeItems: 'center', fontSize: 12, color: '#991b1b' }}>no se pudo cargar</div>
  if (!src) return <div style={{ ...style, display: 'grid', placeItems: 'center', fontSize: 12, color: '#94a3b8' }}>cargando…</div>
  return <img src={src} alt={alt} style={style} onClick={onClick} title={title} />
}
